import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { CASE_STATUS_LABEL, type CaseStatus } from '@/features/cases/types'

/**
 * The one place every screen renders a case's pipeline status — `published` reads as the
 * "complete" `default` variant, every earlier status as `secondary`. `shrink-0` is baked in since a
 * status label (e.g. "Consultation Scheduled") must never be the thing that shrinks/wraps in a flex
 * row; pair it with `min-w-0 truncate` on whatever sibling label sits next to it.
 */
export function CaseStatusBadge({ status, className }: { status: CaseStatus; className?: string }) {
  return (
    <Badge
      variant={status === 'published' ? 'default' : 'secondary'}
      className={cn('shrink-0', className)}
    >
      {CASE_STATUS_LABEL[status]}
    </Badge>
  )
}
